export default __webpack_public_path__ + "images/09c21d730bfdbb138951caf316ac7166-badge-my-tools.svg";